import React from "react";
import "./index.css";
import s1 from "../../assets/s1.png";
import s2 from "../../assets/s2.png";
import s3 from "../../assets/s3.png";
import s4 from "../../assets/s4.png";
import s5 from "../../assets/s5.png";
import s6 from "../../assets/s6.png";
export default function Soultion() {
  return (
    <div>
      <div className="soultion">
        <h2>平台介绍</h2>
        <div className="xian"></div>
        <div className="en">Soultion</div>
        <div
          style={{ backgroundColor: "RGB(251,251,251)" }}
          className="zhengwen"
        >
          <h1>supOS介绍</h1>
          <div class="link-top"></div>
          <div className="box">
            <p>
              supOS工业操作系统软件是企业连接工厂、设备、人员和产品等全信息数据的工业互联网平台、工业大数据平台、工业人工智能平台,主要包含边缘侧数据集成、平台侧全域数据管理和应用侧工业APPs等功能。通过数字化工厂建模实现工厂的全信息模型构建,利用平台的数据治理和综合利用能力,实现工厂元数据的对象化组织、工业大数据的DIY分析以及工业APP的组态开发。supOS工业操作系统旨以集成化、数字化、智能化手段解决工厂生产控制、生产管理和企业经营的有效融合,实现企业运营水平的有效提升。
            </p>
          </div>
          <br></br>
          <h1>运行环境</h1>
          <div class="link-top"></div>
          <div className="box">
            <p>
              用户需在操作系统环境下使用Chrome V84及以上版本浏览器访问supOS。
            </p>
            <br />
            <p>
              以下为服务器推荐配置,实际配置要求取决于企业规模、支持的位号、客户端使用数量等。
            </p>
          </div>
          <br></br>
          <h1>登录</h1>
          <div class="link-top"></div>
          <div className="box">
            <p>
              在Chrome V84及以上版本浏览器中输入服务器地址,例如 http:
            //IP地址:8080,在用户登录界面输入用户名及密码,点击[登录]按钮,登录成功,首次登录后请按提示修改密码。
            </p>
            <br></br>
            <img src={s1} alt="" className="imga" />
            <br></br>
            <p style={{ textAlign: "center" }}>登录界面</p>
            <br></br>
            <p>
              * 语言:可选择操作界面的语言为“简体中文”或“English”; *
              记住用户名:在浏览器中记住用户名,下次登录默认使用该用户名;
            </p>
            <br></br>
            <img src={s2} alt="" className="imga" />
            <br></br>
            <p style={{ textAlign: "center" }}>密码修改</p>
          </div>

          <h1>界面认识</h1>
          <div class="link-top"></div>
          <h3>运行期界面</h3>
          <div className="box">
            <p>
              登录supOS后进入运行期界面,界面信息分成四部分,包括功能区(A区域)、菜单(B区域)、工具栏(C区域)、显示界面(D区域)。如下图所示:
            </p>

            <p>运行期使用说明详见《supOS运行监控管理软件用户手册》。</p>
            <br></br>
            <img src={s3} alt="" className="imga" />
            <p style={{ textAlign: "center" }}>软件界面</p>
            <h3>运行期界面</h3>
            <p>
              点击左下角图标进入设计期界面,设计期界面分成四部分,包括功能区(A区域)、菜单(B区域)、系统信息管理(C区域)、显示信息(D区域)。
            </p>
            <br></br>
            <img src={s4} alt="" className="imga" />
            <p style={{ textAlign: "center" }}>组态期界面</p>
            <p>
              * 点击功能区LOGO,返回至运行期界面首页; *
              点击功能区图标,收起菜单栏,显示缩略图标;
            </p>
            <h3>组态期菜单</h3>
            <h4>采集节点管理</h4>
            <p>
              1.supOS工业操作系统平台实现数据采集站的鉴权管理及连接状态管理。
            </p>
            <p>
              2.状态管理:提供采集器软件与平台之间的连接状态、采集器源点通道状态的管理。
            </p>
            <h4>对象模型管理</h4>
            <p>
              将企业内所有的车间、设备、物料、产品等进行对象化建模与管理。平台中的对象模型包括对象模板、对象实例、功能集合、标签管理、数据集合等。
            </p>

            <p>
              1.对象模板:对同类型的对象进行描述信息的模型集合,通过继承对象模板的方式可快速创建同类型的对象实例。对象模板只能继承一个其他模板,对象实例只能继承一个对象模板。对象模板具有基础描述信息、属性、服务、事件、订阅功能;
            </p>
            <p>
              2.对象实例:表示具有业务关联关系的主体在生命期内的数据信息模型。对象实例可通过继承对象模板的方式快速创建。对象实例具有基础描述信息、属性、服务、事件、订阅功能;
            </p>
            <p>
              3.功能集合:标识不同对象模板和对象实例业务子集,可包括对象实例或对象模板的基础描述信息、属性、服务、事件、订阅方法,用于实现功能集的批量创建和视角查看。功能集合具有新增、删除、参照复制等功能,不具备继承功能;
            </p>
            <p>4.标签管理:对系统所有的对象贴标签归类;</p>
            <p>
              5.数据集合:平台用于描述用户自定义的复杂数据结构。每个字段代表一个特定变量,每一行对应某个对象数据集。
            </p>

            <h4>企业组织架构</h4>
            <p>
              企业组织架构形象地反映了组织内各机构,可以帮助企业快速搭建组织结构和人员管理。
            </p>
            <p>
              公司管理:用于集团型企业内部管理,可以通过创建多级公司实现分/子公司、兄弟公司或上下级公司对组织、人员、用户、角色、内部数据的独立管理;
            </p>
            <p>组织管理:根据公司的人力资源关系,构建与管理公司内部门及岗位;</p>
            <p>组织管理:根据公司的人力资源关系,构建与管理公司内部门及岗位;</p>
            <h4>用户安全管理</h4>
            <p>1.用户管理:配置用户,进行权限管理;</p>
            <p>2.角色管理:对用户角色进行定义,可给不同的角色分配相应权限;</p>
            <p>3.角色管理:对用户角色进行定义,可给不同的角色分配相应权限;</p>
            <p>4.黑白名单:设置系统访问的黑/白名单并对其进行管理。</p>
            <h4>APP设计器</h4>
            <p>
              提供工业APP软件的组态式开发环境,通过图形化、组件化、模块化的向导式应用构建,利用平台提供的表单设计和工作流设计工具,实现应用场景和业务流程的分析和设计,满足流程监控、在线报表、工业APP业务管理页面、工作流管理、Dashboard分析、大屏画面应用等为一体的混合业务编排和场景设计要求。
            </p>
            <h4>APP管理</h4>
            <p>
              提供对于打包的工业APP或第三方工业APP管理页面,控制工业APP安装、启动或停止、卸载,用户可以查看关于工业APP的相关信息,但无法对已安装的工业APP进行二次编辑,工业APP启动后配置用户的页面权限和使用与本地APP设计器中的工业APP使用方式一致。
            </p>
            <h4>计算任务</h4>
            <p>
              实时数据转储:利用该功能可以将supOS工业操作系统中管理的工业实时数据转储到指定的关系数据库;
            </p>
            <h4>消息管理</h4>
            <p>1.类型配置:设置通知的发送类型,以站内信、邮件等形式发送通知;</p>
            <p>
              2.任务管理:设置消息的通知方式（邮件、站内信）、内容模板以及主题设置;
            </p>
            <p>
              3.接收情况:查看系统接收信息的情况,包括接收人、发送状态、阅读状态、发送时间等。
            </p>
            <h4>运维管理</h4>
            <p>
              服务配置:集成与管理ADP平台的工业APP,控制APP添加、安装、修改、卸载等操作;
            </p>
            <p>
              微服务模块配置:用于集成ADP平台的微服务模块,用于兼容ADP平台的工业APP的集成。
            </p>
            <h4>系统管理</h4>
            <p>
              菜单配置:设置系统菜单及APP菜单的启用、暂停,设置菜单的显示名称、菜单排序,设置APP菜单的公司权限、设置第三方APP操作列表等;
            </p>
            <p>
              系统配置:AD域访问配置、打印服务授权、AK/SK授权、基础镜像管理、密码配置、APP配置等系统配置项;
            </p>
            <p>
              系统编码:系统提供统一系统编码配置,来存储下拉框中的选项,比如性别包含“男”、“女”,学历包含“研究生”、“学士”等等,在工业APP组态时调用系统编码可以自动填充下拉选项。系统包含默认的系统编码,用户也可以自己定义新的系统编码;
            </p>
            <p>
              国际化管理:通过国际化管理系统配置可以适应多种语言环境,系统支持中文（简体）、中文（香港）、英文（美国）语言包。用户可以添加自定义的内容及对应翻译,选择相应的语言,系统按选择语言进行适配;
            </p>
            <h4>全局配置</h4>
            <p>配置关系数据库源,用于连接第三方关系数据库的统一配置。</p>

            <h1>系统信息管理</h1>
            <div class="link-top"></div>
            <h3>关于supOS</h3>
            <p>
              点击系统信息管理区域图标,对应信息界面显示系统版本信息及系统配额。系统配额包含网页用户会话数、采集器数、时序位号处理以及订阅有效期,此处参数通过加密狗授权配置的额度显示,若使用了等于限额,无法再新增需要更新加密狗的配置增加授权。
            </p>
            <p>
              1.网页用户会话数:可同时登录的用户数量,超过限额总量的用户无法登录;
            </p>
            <p>
              2.采集器数:采集器接入数量,超过限额总量采集器无法完成鉴权审核接入supOS;
            </p>
            <p>
              3.时序位号处理:时序位号接入supOS数量,超过限额总量属性值不展示,时间戳会更新,属性值状态码显示100000000000000;
            </p>
            <p>4.订阅有效期:订阅的有效期,私有化部署为永久,蓝卓云ESS为有效期;</p>
            <img src={s5} alt="" className="imga" />
            <br></br>
            <p style={{ textAlign: "center" }}>关于</p>
            <h3>系统设置</h3>
            <p>点击系统信息管理区域图标,对应信息界面显示系统信息管理页面。</p>
            <br></br>
            <img src={s6} alt="" className="imga" />
            <br></br>
            <p style={{ textAlign: "center" }}>系统设置</p>
            <br></br>
            <h4>基本设置</h4>
            <p>
              默认首页:设置登录系统后的首页显示页,若选择系统自带桌面系统,用户在运行期可以根据各自需求自定义默认桌面,自定义过程请参考《supOS运行监控管理软件用户手册》。
            </p>
            <p>
              显示导航:默认不勾选,勾选此选项后,登录supOS后的首页左侧将显示菜单列表。
            </p>
            <br></br>
          </div>
        </div>
      </div>
      <div className="clear"></div>
    </div>
  );
}
